import React from "react";
import { useState, useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  Chip,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TableContainer,
} from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import SearchField from "react-search-field";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Option from "./Option";
import Intialize from "./Initialize";
import Scheduleclock from "./scheduleclock";
import Terminated from "./Terminated";

// import Startmessage from "./Startmessage";
// import Stopmessage from "./Stopmessage";
// import FailedConUpdatemessage from "../FailedConUpdatemessage";
// import FailedMessage from "../FailedMessage";
// import FailedStopmessage from "../FailedStopmessage";
// import FailedStartmessage from "../FailedStartmessage";
// import Retryingmessage from "../Retryingmessage";
// import Failedaddconcreate from "../Failedaddconcreate";
// import FailedAddmessage from "../FailedAddmessage";
// import FailedConCreatemessage from "../FailedConCreatemessage";
// import FailedCreatemessage from "../FailedCreatemessage";
// import FailedDeletemessage from "../FailedDeletemessage";
// import Failedremovemessage from "../Failedremovemessage";
// import FailedAddConUpdatemessage from "../FailedAddConUpdatemessage"
// import FailedCordonmessage from "../FailedCordonmessage"

const delay = 5;

const options = [
  { id: 1, name: "Lab Name", value: "name" },
  // { id: 2, name: "Status", value: "status" },
];

const LabList = ({ ...rest }) => {
  function DateTime1(startDate, startTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // const startDate1 = new Date(startDate).toLocaleString("en-GB", {
    //   timeZone: `${timezone}`,
    // });
    const startDate1 = new Date(startDate + "T" + startTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startDate2 = startDate1.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-");

    const startTime1 = new Date(
      startDate + "T" + startTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);

    const startDateTime = startDate3 + "" + startTime3;

    return startDateTime;
  }

  function DateTime2(endDate, endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // const endDate1 = new Date(endDate).toLocaleString("en-GB", {
    //   timeZone: `${timezone}`,
    // });
    const endDate1 = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-");
    const endTime1 = new Date(
      endDate + "T" + endTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);

    const endDateTime = endDate3 + "" + endTime3;

    return endDateTime;
  }

  const [instancelist, setinstancelist] = useState([]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetch(`${process.env.REACT_APP_API_URL}/api/wiselabs/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (data.detail) {
          } else {
            setinstancelist(data);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, instancelist.length - page * rowsPerPage);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const id = open ? "simple-popover" : undefined;

  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const [searchitems, setSearchItems] = React.useState(0);

  return (
    <>
      {/* <ButtonGroup
        sx={{ mr: 2 }}
        variant="outlined"
        style={{
          backgroundColor: "#ffff",
          color: "rgb(90, 90, 90)",
          border: "1px solid rgb(221, 221, 221)",
        }}
        aria-label="split button"
      >
        <Button
          style={{
            width: "150px",
            backgroundColor: "#ffff",
            color: "rgb(90, 90, 90)",
            border: "1px solid rgb(221, 221, 221)",
          }}
        >
          {options[selectedIndex].name} {" = "}
        </Button>
        <Button
          style={{
            backgroundColor: "#ffff",
            color: "rgb(90, 90, 90)",
            border: "1px solid rgb(221, 221, 221)",
          }}
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleClick}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Paper>
          <MenuList id="split-button-menu">
            {options.map((option, index) => (
              <MenuItem
                key={option.name}
                selected={index === selectedIndex}
                onClick={(event) => handleMenuItemClick(event, index)}
              >
                {option.name}
              </MenuItem>
            ))}
          </MenuList>
        </Paper>
      </Popover>
      <SearchField
        value={searchitems}
        placeholder="Search..."
        onChange={(event) => {
          setSearchItems(event);
        }}
        classNames="test-class"
      /> */}
      <Box style={{ marginTop: "-30px" }} >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            sx={{ flex: "1 1 100%" }}
            style={{
              fontSize: "x-large",
              lineHeight: "2.5",
              paddingLeft: "24px",
            }}
            color="textPrimary"
            variant="body1"
          >
            Wise
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "-20px", marginBottom: "10px", paddingX: "10px", '@media (max-width: 768px)': { flexDirection: 'column', marginTop: 0 } }}>
          <SearchField
            value={searchitems}
            placeholder="Search by Lab Name"
            onChange={(event) => {
              setSearchItems(event);
            }}
            classNames="test-class"
          />
        </Box>
      </Box>
      <Box sx={{ pt: 3 }}>
        <Card {...rest}>
          <PerfectScrollbar>
            <Box sx={{ minWidth: 1000 }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Lab Name</TableCell>
                      <TableCell>Number of Trainee</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Technology</TableCell>
                      <TableCell>Lab ID</TableCell>
                      <TableCell>Start Duration</TableCell>
                      <TableCell>End Duration</TableCell>
                      <TableCell align="center" width="10%">
                        Budget Credits
                      </TableCell>
                      <TableCell align="center" width="10%">
                        Spent
                      </TableCell>
                      <TableCell>Actions</TableCell>
                      <TableCell>Details</TableCell>
                    </TableRow>
                  </TableHead>
                  {instancelist.length > 0 ? (
                    <TableBody>
                      {instancelist
                        .filter((val) => {
                          if (searchitems == "") {
                            return val;
                          } else if (
                            val[options[selectedIndex].value]
                              .toLowerCase()
                              .includes(searchitems.toLowerCase())
                          ) {
                            return val;
                          }
                        })
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((instance) =>
                          instance.application === "wise" ? (
                            <TableRow hover key={instance.id}>
                              <TableCell align="center">
                                {instance.name}
                              </TableCell>
                              <TableCell align="center">
                                {instance.number_of_trainee}
                              </TableCell>
                              <TableCell align="center">
                                {instance.status === "Creating" ? (
                                  <Chip
                                    color="primary"
                                    label={instance.status}
                                    size="small"
                                  />
                                ) : instance.status === "Scheduled" ? (
                                  <Chip
                                    color="primary"
                                    style={{
                                      backgroundColor: "rgb(44 189 186)",
                                    }}
                                    label={instance.status}
                                    size="small"
                                  />
                                ) : instance.status === "Running" ? (
                                  <Chip
                                    color="primary"
                                    style={{ backgroundColor: "#00a200" }}
                                    label={instance.status}
                                    size="small"
                                  />
                                ) : instance.status === "Stopped" ? (
                                  <Chip
                                    color="primary"
                                    style={{
                                      backgroundColor: "rgb(228 193 3 / 94%)",
                                    }}
                                    label={instance.status}
                                    size="small"
                                  />
                                ) : instance.status === "Cordoned" ? (
                                  <Chip
                                    color="primary"
                                    style={{
                                      backgroundColor: "rgb(98 95 80 / 94%)",
                                    }}
                                    label={instance.status}
                                    size="small"
                                  />
                                ) : (
                                  <Chip
                                    color="primary"
                                    style={{
                                      backgroundColor: "rgb(228 3 3 / 94%)",
                                    }}
                                    label={instance.status}
                                    size="small"
                                  />
                                )}
                              </TableCell>
                              <TableCell align="center">
                                {instance.application}
                              </TableCell>
                              <TableCell align="center">
                                {instance.id}
                              </TableCell>
                              <TableCell align="center">
                                {DateTime1(
                                  `${instance.start_date}`,
                                  `${instance.start_time}`
                                )}
                              </TableCell>
                              <TableCell align="center">
                                {DateTime2(
                                  `${instance.end_date}`,
                                  `${instance.stop_time}`
                                )}
                              </TableCell>
                              <TableCell align="center">
                                <Typography
                                  variant="contained"
                                  color="Primary"
                                  align="center"
                                >
                                  {`${instance.budget}`}
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography
                                  variant="contained"
                                  color="Primary"
                                  align="center"
                                >
                                  {`${instance.spent}`}
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Option
                                  InstanceID={instance.id}
                                  name={instance.name}
                                  count={instance.number_of_trainee}
                                  status={instance.status}
                                  spent={instance.spent}
                                  budget={instance.budget}
                                  start_date={instance.start_date}
                                  start_time={instance.start_time}
                                  end_date={instance.end_date}
                                  end_time={instance.stop_time}
                                  billingtype={instance.billingtype}
                                  machine_count={instance.machine_count}
                                  number_of_trainee={instance.number_of_trainee}
                                  application={instance.application}
                                  lab_id={instance.id}
                                />
                              </TableCell>
                              {instance.application === "wise" ? (
                                <TableCell align="center">
                                  <Button size="sm">
                                      <Link
                                        to={{
                                          pathname: "/app/wiselab/instanceedit",
                                        }}
                                        onClick={() => {
                                          localStorage.setItem(
                                            "InstanceID",
                                            instance.id
                                          );
                                        }}
                                        style={{ color: "#FFF" }}
                                      >
                                        <ArrowRightAltIcon color="primary" />
                                      </Link>
                                    </Button>
                                  {/* {instance.status === "Running" ||
                                    instance.status === "Stopped" ? (
                                    <Button size="sm">
                                      <Link
                                        to={{
                                          pathname: "/app/wiselab/instanceedit",
                                        }}
                                        onClick={() => {
                                          localStorage.setItem(
                                            "InstanceID",
                                            instance.id
                                          );
                                        }}
                                        style={{ color: "#FFF" }}
                                      >
                                        <ArrowRightAltIcon color="primary" />
                                      </Link>
                                    </Button>
                                  ) : instance.status === "Scheduled" ? (
                                    <Scheduleclock />
                                  ) : instance.status === "Creating" ? (
                                    <Intialize />
                                  ) : instance.status === "Stopping" || instance.status === "stopping" || instance.status === "stop initiated" || instance.status === "Stop Initiated" ? (
                                    <Stopmessage />
                                  ) : instance.status === "Starting" || instance.status === "starting" || instance.status === "start initiated" || instance.status === "Start Initiated" ? (
                                      <Startmessage />
                                  ) : instance.status === "failed_con_update" ? (
                                    <FailedConUpdatemessage />
                                  ) : instance.status === "Failed" ? (
                                    <FailedMessage />
                                  ) : instance.status === "failed_stop" ? (
                                    <FailedStopmessage />
                                  ) : instance.status === "failed_start" ? (
                                    <FailedStartmessage />
                                  ) : instance.status === "failed_start" ? (
                                    <FailedStartmessage />
                                  ) : instance.status === "Retrying" ? (
                                    <Retryingmessage />
                                  ) : instance.status === "failed_add_con_create" ? (
                                    <Failedaddconcreate />
                                  ) : instance.status === "failed_add" ? (
                                    <FailedAddmessage />
                                  ) : instance.status === "failed_con_create" ? (
                                    <FailedConCreatemessage />
                                  ) : instance.status === "failed_add_con_update" ? (
                                    <FailedAddConUpdatemessage />
                                  ) : instance.status === "failed_create" ? (
                                    <FailedCreatemessage />
                                  ) : instance.status === "failed_delete" ? (
                                    <FailedDeletemessage />
                                  ) : instance.status === "failed_remove" ? (
                                    <Failedremovemessage />
                                  ) : instance.status === "failed_cordon" ? (
                                    <FailedCordonmessage />
                                  ) : (
                                    <Terminated />
                                  )} */}
                                </TableCell>
                              ) : (
                                <TableCell align="center">
                                  {instance.status === "Running" ||
                                    instance.status === "Stopped" ? (
                                    <Button size="sm">
                                      <Link
                                        to={{
                                          pathname: "/app/wiselab/instanceedit",
                                        }}
                                        onClick={() => {
                                          localStorage.setItem(
                                            "InstanceID",
                                            instance.id
                                          );
                                        }}
                                        style={{ color: "#FFF" }}
                                      >
                                        <ArrowRightAltIcon color="primary" />
                                      </Link>
                                    </Button>
                                  ) : instance.status === "Scheduled" ? (
                                    <Scheduleclock />
                                  ) : instance.status === "Creating" ? (
                                    <Intialize />
                                  ) : (
                                    <Terminated />
                                  )}
                                </TableCell>
                              )}
                            </TableRow>
                          ) : (
                            ""
                          )
                        )}
                    </TableBody>
                  ) : (
                    <TableBody align="center">
                      <TableCell align="center">No Data Available</TableCell>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {instancelist.length > 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '20px' }}>
                  <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={instancelist.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
                </Box>
              ) : (
                ""
              )}
            </Box>
            <Divider />
          </PerfectScrollbar>
        </Card>
      </Box>
    </>
  );
};

export default LabList;
